import { Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { useSiteState } from "../../../../utils/useSiteState";
import FormHolder from "../../../../components/Form/FormHolder";
import Form from "../../../../components/Form";
import FormFieldErrors from "../../../../components/Form/FormFieldErrors";
import accentsConfig from "../../../../accents.config";

const SiteSettingsFontsAndColorsPage = () => {
  const { site } = useSiteState();

  const getDefaults = () => {
    const { tint } = site;

    return {
      tint,
    };
  };

  const onSubmit = async (responseData: any) => {
    toast("Updated font and accent colour settings", { type: "success" });
  };

  return (
    <>
      <title>Fonts and Colours</title>
      <FormHolder>
        <Form
          getDefaults={getDefaults}
          onCompleted={onSubmit}
          buttonTitle="Save Settings"
          endpoint={`sites/${site.id}`}
          method="put"
          render={({ errors, control }) => (
            <>
              <h4 className="font-medium text-xl text-white">
                Font and Colours
              </h4>
              <p className="text-sm font-light text-gray-200">
                Choose your site font and your site accent colour.
              </p>

              <div className="mb-4 mt-6">
                <label className="mb-2 block ml-4 text-sm font-medium">
                  Accent Color
                </label>

                <Controller
                  name="tint"
                  control={control}
                  rules={{
                    required: true,
                  }}
                  render={({
                    field: { onChange, value },
                  }: any): JSX.Element => (
                    <div className="grid grid-cols-12 gap-4">
                      {Object.keys(accentsConfig).map((color) => (
                        <div
                          key={color}
                          role="button"
                          tabIndex={0}
                          onClick={() => onChange(color)}
                          className={`bg-tint-${color} p-5 rounded-md border-2 ${
                            value === color ? "border-white" : "border-gray-800"
                          } cursor-pointer `}
                        ></div>
                      ))}
                    </div>
                    // <TextInput
                    //   value={value}
                    //   onChange={onChange}
                    //   invalid={!!errors.subdomain}
                    //   placeholder="Site subdomain"
                    // />
                  )}
                />

                <FormFieldErrors
                  errors={errors}
                  field="subdomain"
                  requiredMessage="Site subdomain is required"
                />
              </div>
            </>
          )}
        />
      </FormHolder>
    </>
  );
};

export default SiteSettingsFontsAndColorsPage;
